<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>{{pageTitle}}</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info btn_right" v-on:click="back">キャンセルする</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="modify">
          <div class="form-group"></div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>ID</label>
              </div>
              <div class="col-9">
                <input type="text" v-model="hospital.hospitalCode" class="form-control" :placeholder="[[tenantCode]]" disabled>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>名称</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="120" v-model="hospital.hospitalName" class="form-control" autocomplete="off" :placeholder="[[tenantName]]" required>
              </div>
            </div>
          </div>
          <div class="form-group" v-if="isSuper">
            <div class="row">
              <div class="col-3">
                <label>有効期限</label>
              </div>
              <div class="col-2">
                <input type="number" min="1" max="8760" v-model="hospital.firstTimeOut" class="form-control" autocomplete="off" required>
              </div>
              <div class="col-7">
                <label style="margin-top: 0.5rem;">時間</label>
              </div>
            </div>
          </div>
          <div class="form-group" v-if="isSuper">
            <div class="row">
              <div class="col-4">
                <label>チャットの画像送信</label>
              </div>
              <div class="col-4">
                <input name="isAvailableImage" id="imageOn" type="radio" value="true" v-model="hospital.isAvailableImage" required>
                <label for="imageOn" class="radio-label">利用する</label>
              </div>
              <div class="col-4">
                <input name="isAvailableImage" id="imageOff" type="radio" value="false" v-model="hospital.isAvailableImage" required>
                <label for="imageOff" class="radio-label">利用しない</label>
              </div>
            </div>
          </div>
          <div class="form-group" v-if="isSuper">
            <div class="row">
              <div class="col-4">
                <label>階層グループ</label>
              </div>
              <div class="col-4">
                <input name="isHierarchyGroupEnabled" id="hierarchyOn" type="radio" value="true" v-model="hospital.isHierarchyGroupEnabled" required>
                <label for="hierarchyOn" class="radio-label">利用する</label>
              </div>
              <div class="col-4">
                <input name="isHierarchyGroupEnabled" id="hierarchyOff" type="radio" value="false" v-model="hospital.isHierarchyGroupEnabled" required>
                <label for="hierarchyOff" class="radio-label">利用しない</label>
              </div>
            </div>
          </div>
          <div class="form-group" v-if="isSuper">
            <div class="row">
              <div class="col-4">
                <label>ビデオ通話カンファレンス</label>
              </div>
              <div class="col-4">
                <input name="isUseConference" id="conferenceOn" type="radio" value="true" v-model="hospital.isUseConference" required>
                <label for="conferenceOn" class="radio-label">利用する</label>
              </div>
              <div class="col-4">
                <input name="isUseConference" id="conferenceOff" type="radio" value="false" v-model="hospital.isUseConference" required>
                <label for="conferenceOff" class="radio-label">利用しない</label>
              </div>
            </div>
          </div>
          <div class="form-group" v-if="isSuper">
            <div class="row">
              <div class="col-4">
                <label>スレッド機能</label>
              </div>
              <div class="col-4">
                <input name="isThreadFunctionEnabled" id="threadOn" type="radio" value="true" v-model="hospital.isThreadFunctionEnabled" required>
                <label for="threadOn" class="radio-label">利用する</label>
              </div>
              <div class="col-4">
                <input name="isThreadFunctionEnabled" id="threadOff" type="radio" value="false" v-model="hospital.isThreadFunctionEnabled" required>
                <label for="threadOff" class="radio-label">利用しない</label>
              </div>
            </div>
          </div>
          <div class="form-group" v-if="isSuper">
            <div class="row">
              <div class="col-4">
                <label>アプリからのチーム追加・編集</label>
              </div>
              <div class="col-4">
                <input name="isEditableTeam" id="teamOn" type="radio" value="true" v-model="hospital.isEditableTeam" required>
                <label for="teamOn" class="radio-label">許可する</label>
              </div>
              <div class="col-4">
                <input name="isEditableTeam" id="teamOff" type="radio" value="false" v-model="hospital.isEditableTeam" required>
                <label for="teamOff" class="radio-label">許可しない</label>
              </div>
            </div>
          </div>
          <div class="form-group" v-if="isSuper">
            <div class="row">
              <div class="col-4">
                <label>Microsoftアカウントでログイン</label>
              </div>
              <div class="col-4">
                <input name="useFederation" id="federationOn" type="radio" value="true" v-model="hospital.useFederation" required>
                <label for="federationOn" class="radio-label">許可する</label>
              </div>
              <div class="col-4">
                <input name="useFederation" id="federationOff" type="radio" value="false" v-model="hospital.useFederation" required>
                <label for="federationOff" class="radio-label">許可しない</label>
              </div>
            </div>
          </div>
          <div class="form-group" v-if="this.hospital.useFederation == 'true' && isSuper">
            <div class="row">
              <div class="col-3">
                <label>IDプロバイダー名</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="40" v-model="hospital.idProvider" class="form-control" autocomplete="off" placeholder="IDプロバイダー名" :required="this.hospital.useFederation == 'true'? true: false">
              </div>
            </div>
          </div>
          <div class="form-group" v-if="isSuper">
            <div class="row">
              <div class="col-4">
                <label>同一ユーザーでの複数端末からの重複ログイン</label>
              </div>
              <div class="col-4">
                <input name="isDoubleLoginDisabled" id="doubleLoginOn" type="radio" value="true" v-model="hospital.isDoubleLoginDisabled" required>
                <label for="doubleLoginOn" class="radio-label">制限する</label>
              </div>
              <div class="col-4">
                <input name="isDoubleLoginDisabled" id="doubleLoginOff" type="radio" value="false" v-model="hospital.isDoubleLoginDisabled" required>
                <label for="doubleLoginOff" class="radio-label">制限しない</label>
              </div>
            </div>
          </div>
          <div class="form-group" v-if="isSuper">
            <div class="row">
              <div class="col-4">
                <label>外線・内線連動</label>
              </div>
              <div class="col-4">
                <input name="enableStandardPhone" id="enableStandardPhone" type="radio" value="true" v-model="hospital.enableStandardPhone" required>
                <label for="enableStandardPhone" class="radio-label">利用する</label>
              </div>
              <div class="col-4">
                <input name="enableStandardPhone" id="disableStandardPhone" type="radio" value="false" v-model="hospital.enableStandardPhone" required>
                <label for="disableStandardPhone" class="radio-label">利用しない</label>
              </div>
            </div>
          </div>
          <button id="modify_button" type="submit" class="btn btn-info btn btn-block">更新する</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import authority from '../../authority'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Modify',
  mixins: [sessions,path,headers],
  props: ['realms','serviceName'],
  data: function(){
    return {
      message: '',
      hospital: {
        hospitalCode: '',
        hospitalName: '',
        firstTimeOut: '',
        continueTimeOut: '',
        isAvailableImage: '',
        isHierarchyGroupEnabled: '',
        isUseConference: '',
        isEditableTeam: '',
        useFederation: '',
        idProvider: '',
        isDoubleLoginDisabled: '',
        isThreadFunctionEnabled: '',
        enableStandardPhone: ''
      }
    }
  },
  computed: {
    isSuper: function () {
      return Number(this.$store.state.user.privilege) === authority.isSuper
    },
    isMessage: function () {
      return this.message.length > 0
    },
    pageTitle: function (){
      return this.serviceName === 'SmartPhone' ? '事業所変更' : '病院変更'
    },
    tenantCode:function (){
      return this.serviceName === 'SmartPhone' ? '事業所コード（必須）' : '病院コード（必須）'
    },
    tenantName:function (){
      return this.serviceName === 'SmartPhone' ? '事業所名（必須）' : '病院名（必須）'
    }
  },
  mounted() {
    this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var hospitalId = this.$route.params.id;
        axios.get("/api/hospital/" + hospitalId, {
          headers: this.headers(accessToken)
        }).then(response => {
          var hospital = response.data.data.hospital;
          this.hospital.hospitalCode = hospital.hospitalCode;
          this.hospital.hospitalName = hospital.hospitalName;
          this.hospital.isAvailableImage = hospital.isAvailableImage;
          this.hospital.isHierarchyGroupEnabled = hospital.isHierarchyGroupEnabled;
          this.hospital.isUseConference = hospital.isUseConference;
          this.hospital.isEditableTeam = hospital.isEditableTeam;
          this.hospital.firstTimeOut = hospital.firstTimeOut;
          this.hospital.useFederation = hospital.federation !== null? "true" : "false";
          this.hospital.idProvider = hospital.federation !== null? hospital.federation.idProvider : "",
          this.hospital.isDoubleLoginDisabled = hospital.isDoubleLoginDisabled,
          this.hospital.isThreadFunctionEnabled = hospital.isThreadFunctionEnabled
          this.hospital.enableStandardPhone = hospital.enableStandardPhone
        }).catch(err => {
          this.message = err.message
        })
      }
    }).catch((err) => {
      this.message = err.message
    })
  },
  methods: {
    modify() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$route.params.id;
          const hospitalData = this.setHospitalData();
          axios.put("/api/hospital/" + hospitalId, {
            hospital: hospitalData
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              if (res.errorMessage.conferenceErrorMessage) {
                const errorMessage = `病院の更新は完了しましたがカンファンレンスへの病院転記に失敗しました。失敗の理由を確認のうえ病院変更画面より再度転記を試みてください。【失敗の理由】${res.errorMessage.conferenceErrorMessage}`;
                this.message = errorMessage;
              } else {
                this.message = res.errorMessage;
              }
            } else {
              alert('更新されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/hospital/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch(err => {
        this.message = err.message
      })
    },
    setHospitalData() {
      const hospital = {
        hospitalCode: this.hospital.hospitalCode,
        hospitalName: this.hospital.hospitalName,
        firstTimeOut: this.hospital.firstTimeOut,
        continueTimeOut: this.hospital.continueTimeOut,
        isAvailableImage: this.hospital.isAvailableImage,
        isHierarchyGroupEnabled: this.hospital.isHierarchyGroupEnabled,
        isUseConference: this.hospital.isUseConference === true || this.hospital.isUseConference === "true",
        isEditableTeam: this.hospital.isEditableTeam,
        useFederation: this.hospital.useFederation,
        idProvider: this.hospital.idProvider,
        isDoubleLoginDisabled: this.hospital.isDoubleLoginDisabled,
        isThreadFunctionEnabled: this.hospital.isThreadFunctionEnabled,
        enableStandardPhone: this.hospital.enableStandardPhone
      }
      return hospital;
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/hospital/index'))
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
.btn_right {
  float:right;
}
#modify_button {
  margin-top: 30px;
}
.radio_label {
  margin-left: 0.5rem;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>